/* eslint-disable */
import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";

import dayjs from "dayjs";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { postData, getData } from "utils/Gateway";
import {
  getConvertedDateText,
  getNextHourSlot,
} from "helper/EventHelper/EventHelper";

const MeetingDetailsModal = ({
  token,
  personId,
  personName,
  setPersonName,
  setPersonId,
  setSelectedMeetingDate,
  setSelectedTimeSlot,
  selectedTimeSlot,
  selectedMeetingDate,
  meetingReason,
  comments,
}) => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [meetingDetails, setMeetingDetails] = useState("");

  const scheduleMeetingHandler = async () => {
    try {
      let scheduleData = {
        reciever: personId,
        meetingdate: selectedMeetingDate,
        starttime: selectedTimeSlot,
        endtime: getNextHourSlot(selectedTimeSlot),
        message: comments,
        meetingdetails: meetingDetails,
        meetingreason: meetingReason,
      };

      let requestUrl =
        url.API_BASE_URL + url.API_SAVE_SCHEDULE_MEETING + `?token=${token}`;

      const response = await postData(requestUrl, scheduleData);

      console.log(response);

      if (response.status) {
        //hide login modal
        let loginModal = document.querySelector("#meeting_details");
        let modal = bootstrap.Modal.getInstance(loginModal);
        modal.hide();

        //show register modal
        let myModal = new bootstrap.Modal(
          document.getElementById("schedule_confirm")
        );
        myModal.show();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <div className="meet_modal">
      <div
        className="modal fade"
        id="meeting_details"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body p-4">
              <div className="meet_date_outer d-flex flex-wrap">
                <div className="left_datepnl w-50">
                  <h5 className="text-primary fs-sm fw-bold text-capitalize mb-2">
                    {personName}
                  </h5>
                  <h3 className="text-primary fs-xl text-uppercase mb-3">
                    60 Minute Meeting
                  </h3>
                  <h5 className="d-flex align-items-center gap-2 mb-2">
                    <i className="material-icons-outlined text-pink fs-sm">
                      schedule
                    </i>
                    <span className="fs-sm fw-bold text-primary">60 min</span>
                  </h5>
                  <h5 className="d-flex align-items-center gap-2 mb-2">
                    <i className="material-icons-outlined text-pink fs-sm">
                      calendar_month
                    </i>
                    <span className="fs-sm fw-bold text-primary">
                      {selectedTimeSlot} - {getNextHourSlot(selectedTimeSlot)},{" "}
                      {getConvertedDateText(selectedMeetingDate)}
                    </span>
                  </h5>
                  <h5 className="d-flex align-items-center gap-2 mb-2">
                    <i className="material-icons-outlined text-pink fs-sm">
                      language
                    </i>
                    <span className="fs-sm fw-bold text-primary">
                      India Standard Time
                    </span>
                  </h5>
                </div>
                <div className="right_datepnl w-50">
                  <h3 className="text-primary mb-4 fs-xl text-uppercase">
                    Enter Details
                  </h3>
                  <div className="schedule_form">
                    <div className="form-group mb-3">
                      <label className="fw-medium mb-2 text-primary fs-sm">
                        {userInfo?.name} {userInfo?.surname}
                      </label>
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-medium mb-2 text-primary fs-sm">
                        {userInfo?.email}
                      </label>
                    </div>
                    <div className="form-group description_fill">
                      <label className="fw-medium mb-2 text-primary fs-sm">
                        Meeting Details
                      </label>
                      <textarea
                        className="form-control"
                        placeholder="Enter details"
                        value={meetingDetails}
                        onChange={(e) => setMeetingDetails(e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer body_bg no-border px-4 pb-3">
              <div className="request_time_row d-flex align-items-center justify-content-between w-100">
                <Link
                  to="#"
                  data-bs-dismiss="modal"
                  data-bs-toggle="modal"
                  data-bs-target="#meeting_setup"
                  className="btn"
                >
                  Back
                </Link>
                <Link
                  to="#"
                  // data-bs-toggle="modal"
                  // data-bs-dismiss="modal"
                  // data-bs-target="#meeting_date4"
                  className="btn primary-btn"
                  onClick={scheduleMeetingHandler}
                >
                  Schedule Event
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingDetailsModal;
